import helpers from '@nsftx/games-sdk-js/src/utility/helpers';
import { getBetName, getOutcomeName } from '@/utility/translationsHelper';

export default function formatter(ticket) {
  const bets = ticket.bets.map((bet) => {
    const formattedBet = {
      id: bet.id,
      status: bet.status,
      round: bet.eventId,
      market: getBetName(bet),
      outcome: Array.isArray(bet.value)
        ? bet.value.join(',')
        : getOutcomeName(bet),
      eventValue: bet.outcome.drawn ?? [],
      stake: bet.amount,
      winnings: bet.winnings,
      value: bet.value,
      system: bet.system,
      type: bet.type,
      odd: bet.odds,
      tax: bet.tax,
    };

    if (bet.system) {
      formattedBet.combinations = helpers.getCombinations(
        bet.value.length,
        bet.system,
      );
    }

    return formattedBet;
  });

  return {
    id: ticket.id,
    payout: ticket.payout,
    payin: ticket.payin,
    payinTax: ticket.payinTax,
    payoutTax: ticket.payoutTax,
    superBonus: ticket.superBonus,
    createdAt: ticket.createdAt,
    status: ticket.status,
    maxPossibleWin: ticket.maxPossibleWin,
    providerBetslipId: ticket.requestUuid,
    isFreeBet: ticket.bonuses,
    bets,
  };
}
